import { api } from '../utils/request'

/**
 * Password API - Form submissions should skip global loader
 * Using skipLoader: true to prevent full-screen loader on form submit
 */

export const generateOtp = async (data) => {
    const resp = await api({
        endpoint: '/otp/generateOtp',
        method: 'POST',
        data,
        skipLoader: true, // Skip loader for form submission
    })
    return resp
}

export const changePassword = async (data) => {
    const resp = await api({
        endpoint: '/user/changePassword',
        method: 'PUT',
        data,
        skipLoader: true, // Skip loader for form submission
    })
    return resp
}

export const forgotPassword = async (data) => {
    const resp = await api({
        endpoint: '/user/forgotPassword',
        method: 'POST',
        data,
        skipLoader: true, // Skip loader for form submission
    })
    return resp
}

